// extracted by mini-css-extract-plugin
export default {"text":"text","text_hide":"text_hide","text_bold":"text_bold","text_decorated":"text_decorated"};